'use strict';
import React, { Fragment } from 'react';
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Link from 'next/link';
import settings from '../../util/settings';
import data from '../../static/json/data';
import Title from '../../components/Title/Title';
import Feature from '../../components/Feature/Feature';

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.AnimationElements = []
    this.ASSET_PATH = settings.ASSET_PATH + 'images/'
  }
  componentDidMount() {
    TweenMax.to(this.container, 0.5, {autoAlpha: 1});
    TweenMax.set(this.AnimationElements, {autoAlpha: 0});
    this.animateIn();
    this.props.refSetter(this.container)
  }
  componentWillUnmount() {
    TweenMax.set(this.container, {autoAlpha: 0});
  }
  animateIn = () => {
    var tl = new TimelineMax({paused: true, delay: 0.5});
    tl.staggerFromTo(this.AnimationElements, 2, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Expo.easeOut}, 0.25);
    tl.play();
  }
  render() {
    this.AnimationElements = []
    return <div
      id="section-products"
      ref={el => this.container = el}
    >
      <div id="products-svg">
        {/* <svg viewBox="0 0 710 300">
          <path fillRule="evenodd"
                d="M133.559,161.936 L75.501,7.165 L0.149,7.165 L0.149,269.249 L56.972,269.249 L56.972,98.186 L108.501,230.822 L156.500,230.822 L207.853,93.582 C207.853,93.582 207.853,153.610 207.853,203.486 C258.833,7.311 258.873,7.170 258.859,7.165 C240.992,7.165 189.323,7.165 189.323,7.165 L133.559,161.936 Z"/>
          <path fillRule="evenodd"
                d="M433.709,269.338 C433.709,269.338 432.551,264.849 430.537,257.046 C416.929,247.939 363.236,215.881 386.278,85.573 C374.948,41.678 366.063,7.255 366.063,7.255 L274.157,7.255 L206.511,269.338 L266.188,269.338 L281.949,203.994 L357.386,203.994 L373.324,269.338 L433.709,269.338 ZM319.490,47.453 L344.813,151.932 L294.345,151.932 L319.490,47.453 Z"/>
          <path fillRule="evenodd"
                d="M514.376,269.708 C523.552,269.708 532.844,268.911 542.258,267.317 C551.669,265.723 559.728,263.629 566.434,261.031 L566.434,209.322 C549.609,214.873 535.199,217.645 523.199,217.645 C507.670,217.645 495.080,215.139 485.435,210.119 C475.787,205.103 468.552,196.572 463.729,184.531 C458.904,172.489 456.494,156.020 456.494,135.125 C456.494,114.821 458.965,98.618 463.906,86.515 C468.847,74.415 476.198,65.738 485.964,60.484 C495.728,55.232 508.200,52.604 523.376,52.604 C537.375,52.604 551.727,54.375 566.434,57.916 L566.434,6.208 C551.374,2.431 535.257,0.541 518.082,0.541 C477.728,0.541 446.700,11.728 424.995,34.098 C403.289,56.472 392.436,90.383 392.436,135.833 C392.436,182.467 402.817,216.436 423.583,237.744 C444.345,259.055 474.610,269.708 514.376,269.708 L514.376,269.708 Z"/>
        </svg> */}
        <img src={this.ASSET_PATH + 'mac.png'} alt='Metals and Alloys Centre logo' style={{ maxWidth: '100%', filter: 'brightness(0.1)' }}/>
      </div>
      <div className="ContentContainer">
        <Title title="PRODUCTS" subtitle="We provide a variety of metals to fit your needs" />
        <div className="row" style={{ justifyContent: 'center' }}>
          { data && data.products &&
            data.products.map((item, index) => {
              return (
                <Fragment>
                  <a href={`/product/${item.url}`} rel="prefetch" className={'product-link'}>
                    <Feature className='col-5 ml-1 mr-1 ml-sm-3 mr-sm-3 col-lg-3 ml-lg-2 mr-lg-2 mb-3' title={item.name} key={index}
                            subtitle={item.description} image={item.image} clickable={true} />
                  </a>
                </Fragment>
              )
            })
          }
        </div>
      </div>
    </div>;
  }
};

export default Products;



// WEBPACK FOOTER //
// ./sections/Products/Products.js